import { lessonErrorMessage, lessonStatusCode } from './lesson-status-code'

const memberIdsIn = (message: string): string[] =>
  message.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi) ?? []

export interface LessonFeedbackUpdateErrorText {
  readonly key: string
  readonly values?: Record<string, string>
}

/**
 * Maps a failed PUT …/feedback onto a translation key.
 * The English phrases are the ones ChangeLessonFeedbackCommandHandler throws.
 */
export const lessonFeedbackUpdateError = (
  error: unknown,
  memberName: (memberId: string) => string,
): LessonFeedbackUpdateErrorText => {
  const message = lessonErrorMessage(error) ?? ''
  const code = lessonStatusCode(error)

  if (message.includes('already answered')) {
    const names = memberIdsIn(message).map((memberId) => memberName(memberId))
    if (names.length > 0) {
      return {
        key: 'lumia.lesson.feedback.removedAnswered',
        values: { names: names.join(', ') },
      }
    }
  }
  if (message.includes('cannot be switched off')) {
    return { key: 'lumia.lesson.feedback.teacherAssessmentStarted' }
  }
  if (message.includes('already ended')) {
    return { key: 'lumia.lesson.feedback.alreadyEnded' }
  }
  if (message.includes('has not started')) {
    return { key: 'lumia.lesson.feedback.updateNotStarted' }
  }
  if (message.includes('can be left out')) {
    return { key: 'lumia.lesson.feedback.excludeStrangers' }
  }
  if (message.includes('at least one')) {
    return { key: 'lumia.lesson.feedback.excludeEveryone' }
  }
  if (code === 404) {
    return { key: 'lumia.lesson.snackbar.feedbackUpdateNotFound' }
  }
  return { key: 'lumia.lesson.snackbar.feedbackUpdateError' }
}
